import React from 'react';
import { DefinitionTooltip } from '@carbon/react';
import styles from './alias-group-pill.module.scss';

// Ported from mock-ui entity-reconciliation v3. The alias-group label rendered
// on the Entity Classification field — plain dotted-underline text (a
// DefinitionTooltip term), NOT a chip. The click-to-open-graph affordance is
// the separate ⓘ icon rendered alongside it by AliasClusterButton.
export type AliasGroupPillState =
  // Cluster fully within the visible list.
  | { kind: 'in-list-only'; groupNumber: number }
  // In-list members AND members outside the visible list.
  | { kind: 'mixed'; groupNumber: number }
  // Only outside members — no peer in the visible list.
  | { kind: 'out-of-list-only' };

const TOOLTIP_TEXT =
  'This entity is aliased to others. Group numbers are assigned for display ' +
  'purposes only — use the ⓘ to view the full alias cluster.';

const AliasGroupPill: React.FC<{ state: AliasGroupPillState }> = ({
  state,
}) => {
  const label =
    state.kind === 'in-list-only'
      ? `Group ${state.groupNumber}`
      : state.kind === 'mixed'
        ? `Group ${state.groupNumber} · + Others`
        : '+ Others';

  return (
    <DefinitionTooltip openOnHover align="bottom" definition={TOOLTIP_TEXT}>
      <span className={styles.label}>{label}</span>
    </DefinitionTooltip>
  );
};

export default AliasGroupPill;
